import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import LevelDots from '../../components/levelDots';

import './LevelMenu.scss';

class LevelDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      anchorEl: null,
      userLevelValue: props.userLevel,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.printLevel = this.printLevel.bind(this);
    this.triggerLevelInputChange = this.triggerLevelInputChange.bind(this);
    this.onMenuSelectHandler = this.onMenuSelectHandler.bind(this);
  }

  onMenuSelectHandler(level) {
    this.setState({ anchorEl: null, userLevelValue: level });
    this.triggerLevelInputChange(level);
  }

  getLevels(level) {
    const levels = [];
    const { userLevelValue } = this.state;
    // eslint-disable-next-line no-plusplus
    for (let i = level; i > 0; i--) {
      levels.push(
        <MenuItem
          key={i}
          onClick={() => this.onMenuSelectHandler(i)}
          className={userLevelValue === i ? 'selectedItem' : ''}
        >
          <LevelDots
            level={i}
            trail
          />
          {i === level && <span className="lineIcon" />}
        </MenuItem>,
      );
    }
    return levels;
  }

  handleClose() {
    this.setState({ anchorEl: null });
  }

  triggerLevelInputChange(level) {
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(this.myRef.current, level);
    this.myRef.current.dispatchEvent(new window.Event('input', { bubbles: true }));
  }

  handleClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  printLevel() {
    const { userLevelValue } = this.state;
    const { userLevel } = this.props;
    /* eslint-disable */
    return isNaN(userLevelValue) || !userLevelValue ? userLevel : userLevelValue;
  }

  render() {
    const { anchorEl, userLevelValue } = this.state;
    const { handleChange, userLevel } = this.props;
    const levelToShow = this.printLevel();
    return (
      <div className="customLevelWrap"> {userLevel ? (
        <div>
          <Button
            aria-owns={anchorEl ? 'simple-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            className="levelBtn"
          >
            <span className="selectedLevel">
              {levelToShow && <LevelDots level={levelToShow} trail />}
            </span>
            <span className="lineIcon" />
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            className="LevelDropdown"
            PopoverClasses={{
              paper: 'LevelDropdownContent'
            }}
          >
            {this.getLevels(userLevel)}
          </Menu>
          <input
            name="level"
            value={userLevelValue}
            onChange={handleChange}
            ref={this.myRef}
            className="dNone"
          />
        </div>
      ) : null}
      </div>
    );
  }
}
export default LevelDropdown;



// WEBPACK FOOTER //
// ./src/containers/DrawingTool/LevelMenu.js